import React from 'react'
import HeadData from 'components/Common/HeadData'

interface Props {
  cruiseLine: App.CruiseLine
}

function CruiseLineHeadData({ cruiseLine }: Props) {
  const currentYear = new Date().getFullYear()
  const title = `${cruiseLine.name} | Best Deals ${currentYear}/${currentYear + 1}/${currentYear + 2}`
  const description = `Looking for voyages with ${cruiseLine.name}? Book your dream cruise at a great price with our exclusive deals. Departure dates in ${currentYear}, ${currentYear + 1} and ${currentYear + 2}.`

  return (
    <HeadData
      title={title}
      description={description}
    />
  )
}

export default CruiseLineHeadData
